import useConfiguration from './useConfiguration';

const useLinkedToLocalion = (solutionId: string) => {
  const { data: configuration } = useConfiguration(solutionId);
  return configuration?.veengu_business_profile?.requireMappingToLocation;
};

export default useLinkedToLocalion;
